import { Component } from '@angular/core';
import { EnumStatusCode } from 'src/app/enum/enumStatusCode';
import { Articledata, ResponseArticle } from 'src/app/shared/models/article';
import { AritcleService } from 'src/app/shared/services/article.service';
import { BaseService } from 'src/app/shared/services/base.service';
import { HomeService } from 'src/app/shared/services/home.service';

@Component({
  selector: 'app-world-list',
  templateUrl: './world-list.component.html',
  styleUrls: ['./world-list.component.scss']
})
export class WorldlistComponent {
  searchOpen = true;
  worldres = new ResponseArticle;
  worldlist: Articledata = {} as Articledata;
  TotalItems=0;
  constructor(
    public homeService: HomeService,
    // private router: Router,
    public baseService: BaseService,
    public aritcleService: AritcleService
  ) {
    // this.Getworldlist()
    this.worldres.FunctionID = 7001;
  }

  // Getworldlist() {
  //   this.worldres.FunctionID = 7001;
  //   this.aritcleService.GetArticleByUnit(this.worldres).subscribe((res) => {
  //     if (res.StatusCode == EnumStatusCode.Success) {
  //       this.worldlist = res.Entries;
  //       console.log(this.worldlist.Data)
  //     }
  //   });
  // }
}
